import React, { MouseEvent } from 'react'
import ReactDOM from 'react-dom'
import cx from 'classnames'
import styles from './brandKindSelect.module.less'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'
import classNames from 'classnames'

interface IBrand {
  id: number
  name: string
  zhName: string
  enName: string
  image: string
}

interface IData {
  index: string[]
  brand: Array<{
    label: string
    list: Array<IBrand>
  }>
  kindNum: number
  photoNum?: number
  onSaleNum?: number
}

interface IKind {
  brandName: string;
  brandId: number;
  kind: string;
  kindName: string;
  kindId: number;
  maxPrice: string;
  minPrice: string;
  newKindId: number;
  price: string;
  thumb: string;
}

interface IState {
  visible: boolean
  secondVisible: boolean
  value: number
  label: string
  kindValue: number
  kindLabel: string
  posX: number
  posY: number
  posSecondX: number
  posSecondY: number
  hover: boolean
}

interface IProp {
  border?: boolean
  onSubmit: (data: IKind | 'all') => void
  dataSource: IData
  kindData: IKind[]
  onBrandSelect: (brand: number) => Promise<void>
  field: 'usedcar' | 'newcar';
  selectLabel: string;
  isShowClear?: boolean;
  onClear?: () => void;
  type?: string;
}

interface IKindPopover {
  value: number
  dataSource: IKind[]
  onSelect: (data: IKind |  'all') => void;
  field: string;
  secondVisible: boolean;
  checkSecondVisible: (flag: boolean) => void;
}

interface IBrandPopover {
  dataSource: IData,
  value: number,
  onSelect: (value: number, label: string) => void,
  field: string;
  secondVisible: boolean;
  checkVisible: () => void,
  kindData: IKind[];
  onSelectKind: (data: IKind |  'all') => void;
  checkSecondVisible: (flag: boolean) => void;
}

function KindPopover(props: IKindPopover) {
  const { value, onSelect, dataSource, field, secondVisible, checkSecondVisible } = props
  return (
    <div style={{ left: secondVisible ? 0 : '215px' }} className={cx(styles['select-popover-list'], styles['border-radius'], styles['kind-popover'])}>
      <PerfectScrollbar options={{ wheelPropagation: false }}>
        <div className={styles['select-popover-section']} >
          <span
            className={cx(styles['select-popover-section-item'], {
              [styles['select-popover-section-item-used']]: field === 'usedcar',
              [styles['active']]: value === 0
            })}
            onClick={() => onSelect('all')}
          >全部車款</span>
        </div>
        {
          dataSource.map(item => (
            <div className={styles['select-popover-section']} key={item.kindId}>
              <span
                className={cx(styles['select-popover-section-item'], {
                  [styles['select-popover-section-item-used']]: field === 'usedcar',
                  [styles['active']]: value === item.kindId
                })
                }
                onClick={() => onSelect(item)}
              >{item.kindName}</span>
            </div>
          ))
        }
      </PerfectScrollbar>
      <div className={styles['select-popover-back']} onClick={() => checkSecondVisible(false)}>返回</div>
    </div >
  )
}

class BrandPopover extends React.Component<IBrandPopover> {

  readonly state = {
    activeIndex: 0
  }

  private scrollRef: (HTMLElement & {
    updateScroll?: any
  }) | undefined;

  private updateRef: any;

  private listView: number[] = [0];

  componentDidUpdate() {
    this.renderListView()
  }

  private handleScroll = (container: any) => {
    const offsetLength = this.listView.length
    for (let i = 0; i < offsetLength; i++) {
      const isActiveTarget = container.scrollTop >= this.listView[i] &&
        (typeof this.listView[i + 1] === 'undefined' || container.scrollTop < this.listView[i + 1])
        if (isActiveTarget) {
          this.setState({
            activeIndex: i
          })
        }
    }
  }

  private renderListView = () => {
    if (this.listView.length > 1 || !this.scrollRef) {
      return
    }
    this.updateRef.updateScroll()
    const children = Array.from(this.scrollRef.children)
    children.filter(ele => ele.classList.contains('tc-select-section')).forEach((item, index) => {
      this.listView.push(item.getBoundingClientRect().height + this.listView[index])
    })
  }

  private jump = (index: number) => {
    if (this.scrollRef) {
      this.scrollRef.scrollTop = this.listView[index]
    }
  }

  render() {
    const { dataSource, value, onSelect, field, secondVisible, checkVisible, kindData, onSelectKind, checkSecondVisible } = this.props
    const { activeIndex } = this.state
    return (
      <>
        <div className={styles['select-popover-header']}>
          <p onClick={checkVisible}>廠牌</p> { secondVisible && <><span>&gt;</span> 車款</>}
        </div>
        <ul className={styles['select-popover-index']}>
          {
            dataSource.index.map((item, index) => (
              <li
                className={cx(styles['select-popover-index-item'], {
                  [styles['select-popover-index-item-used']]: field === 'usedcar',
                  [styles['active']]: index === activeIndex
                })}
                key={item}
                onClick={() => this.jump(index)}
              >{item}</li>
            ))
          }
        </ul>
        <div className={styles['select-popover-list']}>
          <PerfectScrollbar ref={ref => this.updateRef = ref} containerRef={(ref) => { this.scrollRef = ref }} onScrollY={this.handleScroll} options={{ wheelPropagation: false }}>
            {
              dataSource.brand.map(item => (
                <div className={cx(styles['select-popover-section'], 'tc-select-section')} key={item.label} data-index={item.label}>
                  <span className={styles['select-popover-section-header']}>{item.label}</span>
                  {
                    item.list.map(ii => (
                      <span
                        className={cx(styles['select-popover-section-item'], {
                          [styles['select-popover-section-item-used']]: field === 'usedcar',
                          [styles['active']]: value === ii.id
                        })}
                        key={ii.id}
                        onClick={() => onSelect(ii.id, ii.name)}
                      >{ii.name}</span>
                    ))
                  }
                </div>
              ))
            }
          </PerfectScrollbar>
        </div>
        <KindPopover dataSource={kindData} value={value} onSelect={onSelectKind} field={field} secondVisible={secondVisible} checkSecondVisible={checkSecondVisible} />
      </>
    )
  }
}


class Popover extends React.Component<{ visible: boolean, pos: { x: number, y: number }, className?: any, type?: string }> {

  readonly state = {
    mounted: false
  }

  componentDidMount() {
    this.setState({
      mounted: true
    })
  }

  render() {
    const { children, visible, pos, className, type } = this.props
    const { mounted } = this.state;
    const style: React.CSSProperties = type === 'supertest' ?
                    { top: 'unset', left: pos.x, bottom: visible ? '40px': -10000, position: 'fixed' } :
                    { top: visible ? pos.y : -10000, left: pos.x }
    
    console.log(visible);

    return mounted ? ReactDOM.createPortal((
      <div className={cx(styles['select-popover'], {
        [className]: !!className
      })} style={style}>{children}</div>
    ), document.body) : null
  }
}

class BrandKindSelect extends React.Component<IProp, IState> {

  readonly state = {
    visible: false,
    posX: 0,
    posY: 0,
    posSecondX: 0,
    posSecondY: 0,
    secondVisible: false,
    value: 0,
    label: '',
    kindValue: 0,
    kindLabel: '',
    hover: false
  }

  static defaultProps = {
    isShowClear: true
  }

  private containerRef = React.createRef<HTMLDivElement>();

  private brandRef = React.createRef<HTMLDivElement>();

  private kindRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    document.addEventListener('click', this.bindEvent)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.bindEvent)
  }

  private bindEvent = (e: any) => {
    const target = e.target as HTMLElement
    if ((this.state.visible || this.state.secondVisible) && (
      !target.className.includes('select-popover') && !target.className.includes('select-value')
    )) {
      this.setState({
        visible: false,
        secondVisible: false
      })
    }
  }

  private onSelectBrand = (value: number, label: string) => {
    this.setState({
      value,
      label,
      kindLabel: '',
      kindValue: 0
    }, () => {
      this.toggleSecond();
      this.initSecondPos();
    })
    if (value) {
      const { field } = this.props
      this.props.onBrandSelect(value)
    }
  }

  private toggle = (e: MouseEvent, visible?: boolean) => {
    const target = e.target as HTMLElement
    const rect = target.getBoundingClientRect()
    this.setState({
      posX: rect.x + window.scrollX,
      posY: rect.y + rect.height + window.scrollY,
      secondVisible: visible || false,
      visible: visible || !this.state.visible
    })
  }

  private toggleSecond = () => {
    if (this.state.value === 0 || !this.kindRef.current) {
      if (this.brandRef.current) {
        this.toggle({ target: this.brandRef.current } as any, true)
      }
      return
    }
    const rect = this.kindRef.current.getBoundingClientRect()
    this.setState({
      posSecondX: rect.x + window.scrollX,
      posSecondY: rect.y + rect.height + window.scrollY,
      visible: false,
      secondVisible: !this.state.secondVisible
    })
  }

  private initSecondPos = () => {
    if (this.brandRef.current) {
      const target = this.brandRef.current as HTMLElement;
      const rect = target.getBoundingClientRect();
      this.setState({
        posSecondX: rect.x + window.scrollX + 1000,
        posSecondY: rect.y + rect.height + window.scrollY,
      })
    }
  }

  private checkVisible = () => {
    this.setState({
      secondVisible: false
    })
  }

  private onSelectKind = (data: IKind | 'all') => {
    if (data !== 'all') {
      this.setState({
        kindValue: data.kindId,
        kindLabel: data.kindName,
        visible: false,
        secondVisible: false,
      })
      this.onSubmit(data)
      return
    }
    this.setState({
      visible: false,
      secondVisible: false,
    })
    this.props.onSubmit(data)
  }

  private onSubmit = (data: IKind) => {
    this.props.onSubmit(data)
  }

  private onHover = () => {
    if (this.state.hover) {
      return
    }
    this.setState({
      hover: true
    })
  }

  private onLeave = () => {
    if (!this.state.hover) {
      return
    }
    this.setState({
      hover: false
    })
  }

  private onClear = () => {
    this.setState({
      value: 0,
      label: '',
      kindValue: 0,
      kindLabel: '',
    })
    this.props.onClear && this.props.onClear()
  }

  private checkSecondVisible = (flag: boolean) => {
    this.setState({ secondVisible: false })
  }


  render() {
    const { visible, label, value, secondVisible, kindLabel, kindValue, posX, posY, posSecondX, posSecondY, hover  } = this.state
    const { dataSource, kindData, field, selectLabel, isShowClear, border, type } = this.props;

    return (
      <>
        <div className={styles['container']} ref={this.containerRef}>
          <div className={cx(styles['select'], { [styles['open']]: visible, [styles['supertest']]: type === 'supertest' })} onMouseEnter={() => this.onHover()} onMouseLeave={() => this.onLeave()}>
            <span className={cx(styles['select-value'], { [styles['border']]: border })} onClick={this.toggle} ref={this.brandRef}>{ label ? `${label} ${kindLabel}` : selectLabel ? selectLabel : '請選擇廠牌/車款' }</span>
            <Popover visible={visible} pos={{ x: posX, y: posY }} type={type}>
              <BrandPopover 
                dataSource={dataSource} 
                kindData={kindData}
                value={value} 
                field={field} 
                secondVisible={secondVisible} 
                checkVisible={this.checkVisible} 
                onSelect={this.onSelectBrand} 
                onSelectKind={this.onSelectKind}
                checkSecondVisible={this.checkSecondVisible}
              />
            </Popover>
            { hover && <a className={styles['clean-btn']} onClick={this.onClear}></a> }
          </div>
          <div className={styles['search-container']}>
            <span className={cx(styles['search-icon'], { [styles['hover']]: hover, 'bounceInUp': hover, 'animated': hover })} />
          </div>
        </div>
      </>
    )
  }
}

export default BrandKindSelect
